<dialog-window [title]="title" (close)="close()" [modal]="false" focusOnCloseButton="true"> 
    <form class="load-url" (ngSubmit)="load_url()" ngNativeValidate >
        <fieldset>
            <legend>Загрузить по ссылке:</legend>
            <input tabindex="1"  [(ngModel)]="url" (focus)="$event.target.select(); url_focus();" (blur)="url_blur($event)" #inputElement required autocomplete="off" type="url" name="url" class="input-gray" placeholder="Ссылка на плейлист http://" size="30">&nbsp;
            <button tabindex="1"  type="submit" class="blue-button" [disabled]="disableUrl">OK</button>
            <div id="url_list" #urlList [hidden]="urlListHidden">
                <ul>
                    <li *ngFor="let item of url_list" (mousedown)="url = item"><span>{{item}}</span> <b (mousedown)="$event.stopPropagation(); url_remove(item);"  class="remove ionic" title="Удалить">&#xf12a;</b></li>
                </ul>
            </div>
        </fieldset>
    </form> 
    <form class="load-file" >
        <fieldset><legend>Загрузить файл:</legend>
            <input tabindex="1" class="input-gray" type="file" name="file" accept=".m3u, .m3u8" (input)="load_file($event)">
        </fieldset>
    </form>
 </dialog-window>